import React, { useEffect, useState } from "react"
import _ from "lodash"

import { Container, Dimmer, Header, Loader, Responsive, Segment, Table } from "semantic-ui-react"

import { CompanyModal } from "./Company"
import { CyclistOwned, YGRPartner, LeagueOfCyclists } from "./Badges"

// import PartnerImage from "./images/YGR-Partner-Stamp.png"

const URL = "https://zyfdiyimwd.execute-api.us-west-2.amazonaws.com/prod/sheet"

const UP = "ascending"
const DOWN = "descending"

const useCompanies = () => {
  const [companies, setCompanies] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchCompanies = async () => {
      setIsLoading(true)
      const results = await fetch(URL)
      setCompanies(await results.json())
      setIsLoading(false)
    }

    fetchCompanies()
  }, [])

  return { companies, isLoading }
}

const CompanyTable = props => (
  <Table sortable celled fixed unstackable>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell
          sorted={props.column === "name" ? props.direction : null}
          onClick={() => props.handleSort("name")}
        >
          Name
        </Table.HeaderCell>
        <Table.HeaderCell>You can help by</Table.HeaderCell>
        <Table.HeaderCell
          sorted={props.column === "bizType" ? props.direction : null}
          onClick={() => props.handleSort("bizType")}
        >
          Business Type
        </Table.HeaderCell>
        <Table.HeaderCell>Badges</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {props.tableData.map((company, i) => (
        <Table.Row key={`company-${i}`}>
          <Table.Cell textAlign="left">
            <button className="link-button" onClick={() => props.onCompanyClicked(company)}>
              {company.name}
            </button>
          </Table.Cell>
          <Table.Cell textAlign="left">{company.needs}</Table.Cell>
          <Table.Cell>{company.biz_type}</Table.Cell>
          <Table.Cell textAlign="center">
            <CyclistOwned company={company}></CyclistOwned>

            <YGRPartner company={company}></YGRPartner>

            <LeagueOfCyclists company={company}></LeagueOfCyclists>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
)

// const AddCompany = () => (
//   <Link to="/add">
//     <Button primary size="big" className="add-company-button">
//       Add a new company
//       <Icon name="right arrow" />
//     </Button>
//   </Link>
// )

const Hero = props => (
  <Container fluid textAlign="center" id="companies-hero">
    {props.children}
  </Container>
)

const MobileHero = props => (
  <Container text fluid textAlign="center">
    {props.children}
  </Container>
)

const ResponsiveHero = props => (
  <>
    <Responsive as={MobileHero} maxWidth={767}>
      {props.children}
    </Responsive>
    <Responsive as={Hero} minWidth={768}>
      {props.children}
    </Responsive>
  </>
)

export const Companies = () => {
  const { companies, isLoading } = useCompanies()

  const [direction, setDiretction] = useState(UP)
  const [column, setColumn] = useState("name")
  const [company, setCompany] = useState(null)

  const handleSort = key => {
    if (key !== column) {
      setColumn(key)
      setDiretction(UP)
    } else {
      setDiretction(direction === UP ? DOWN : UP)
    }
  }

  const onCompanyClicked = company => {
    setCompany(company)
  }

  const onCloseModal = () => {
    setCompany(null)
  }

  let tableData = _.sortBy(companies, [column])
  if (direction === DOWN) {
    tableData.reverse()
  }

  return (
    <>
      {company && <CompanyModal company={company} onCloseCallback={onCloseModal}></CompanyModal>}

      <ResponsiveHero>
        <Header as="h1">Northern Colorado Cycling Businesses</Header>
        <Header as="h3">
          These local businesses are open for business and could use your support!
        </Header>
      </ResponsiveHero>

      {isLoading && (
        <Container style={{ height: "100%" }}>
          <Dimmer active>
            <Loader content="Loading companies" />
          </Dimmer>
        </Container>
      )}

      {!isLoading && (
        <Container>
          <Segment basic>
            <CompanyTable
              column={column}
              company={company}
              onCompanyClicked={onCompanyClicked}
              tableData={tableData}
              handleSort={handleSort}
            />
          </Segment>
        </Container>
      )}
    </>
  )
}
